import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import Loader from "shared/ui/Loader";
import { ModalProvider } from "app/providers/ModalProvider";
import { UserProvider } from "app/providers/UserProvider";
import { AlertProvider } from "app/providers/AlertProvider";
import { SeoProvider } from "app/providers/SeoProvider";
import { AuthProvider } from "app/providers/AuthProvider";
import { Provider } from "react-redux";
import { store } from "app/store";


export const AppRouter = (component: () => React.ReactNode) => () => (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <UserProvider>
          <AlertProvider>
            <ModalProvider>
              <AuthProvider>
                <SeoProvider>
              {component()}
              </SeoProvider>
              </AuthProvider>
            </ModalProvider>
          </AlertProvider>
        </UserProvider>
      </Provider>
      </Suspense>
    </BrowserRouter>
  );
